export function isInIframe(): boolean {
    return document.body.classList.contains('belayout-blank');
}
